import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProducts } from '../context/ProductsContext';
import { Sparkles, Loader2 } from 'lucide-react';
import ProductCard from './ProductCard';

const ProductsSection = () => {
  const { t } = useTranslation();
  const { products, loading, error } = useProducts();

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cyan-100 px-4 py-2 rounded-full mb-4">
            <Sparkles className="w-4 h-4 text-cyan-600" />
            <span className="text-sm font-semibold text-cyan-700">{t('products.badge')}</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('products.title')} <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-600 to-blue-600">{t('products.titleHighlight')}</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('products.description')}
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <Loader2 className="w-8 h-8 text-cyan-600 animate-spin" />
            <span className="ml-2 text-gray-600">{t('common.loading') || 'Cargando productos...'}</span>
          </div>
        ) : error ? (
          <div className="text-center py-20">
            <p className="text-red-600">{t('common.error') || 'Error al cargar productos'}</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductsSection;
